import {
    useState,
    forwardRef,
    useImperativeHandle,
    useRef,
} from "react"

import TextInput from "../TextInput"
import EmailInputForm from "../EmailInputForm"
import PhoneNumberInput from "../PhoneNumberInput"
import TextAreaInput from "../TextAreaInput";

const EmployeeReference = forwardRef(({ data, readOnly, isMandatory }, ref) => {
    const companyNameRef = useRef()
    const fullNameRef = useRef()
    const jobTitleRef = useRef()
    const relationshipRef = useRef()
    const emailRef = useRef()
    const phoneNumberRef = useRef()
    const commentsRef = useRef()

    const [error, setError] = useState("")

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            const companyNameResult = companyNameRef.current?.validateAndGetData()
            const fullNameResult = fullNameRef.current?.validateAndGetData()
            const jobTitleResult = jobTitleRef.current?.validateAndGetData()
            const relationshipResult = relationshipRef.current?.validateAndGetData()
            const emailResult = emailRef.current?.validateAndGetData()
            const phoneNumberResult = phoneNumberRef.current?.validateAndGetData()
            const commentsResult = commentsRef.current?.validateAndGetData()

            let isValid =
                companyNameResult?.isValid &&
                fullNameResult?.isValid &&
                relationshipResult?.isValid &&
                jobTitleResult?.isValid &&
                emailResult?.isValid &&
                phoneNumberResult?.isValid &&
                commentsResult?.isValid

            const didUserFilledAnyData = fullNameResult.value || jobTitleResult.value || relationshipResult.value


            if (isMandatory || didUserFilledAnyData) {
                const isContactValid = emailResult.value || phoneNumberResult.value?.number
                if (!isContactValid) {
                    setError("Please provide at least one contact method — either an email address or a phone number.")
                }
                isValid = isValid && isContactValid
            }

            return {
                isValid,
                value: {
                    companyName: companyNameResult?.value,
                    fullName: fullNameResult?.value,
                    jobTitle: jobTitleResult?.value,
                    relationship: relationshipResult?.value,
                    email: emailResult?.value,
                    phoneNumber: phoneNumberResult?.value,
                    comments: commentsResult?.value,
                },
            }
        },
    }));

    return (
        <div className="my-4">

            <TextInput
                ref={companyNameRef}
                title="Company Name"
                placeholder="Company Name"
                data={data?.companyName}
                isMandatory={true}
                disabled={readOnly}
            />

            {/* Reference's Full Name */}
            <TextInput
                ref={fullNameRef}
                title="Reference's Full Name"
                placeholder="Enter full name"
                data={data?.fullName}
                isMandatory={true}
                disabled={readOnly}
            />

            {/* Reference's Job Title / Position */}
            <TextInput
                ref={jobTitleRef}
                title="Reference's Job Title / Position"
                placeholder="Enter job title or position"
                data={data?.jobTitle}
                disabled={readOnly}
                isMandatory={true}
            />

            {/* Reference's Relationship to Candidate */}
            <TextInput
                ref={relationshipRef}
                title="Reference's Relationship to Candidate"
                placeholder="Enter relationship to candidate"
                data={data?.relationship}
                isMandatory={true}
                disabled={readOnly}
            />

            {/* Reference's Contact Email */}
            <EmailInputForm
                ref={emailRef}
                title="Reference's Contact Email"
                placeholder="Enter contact email"
                data={data?.email}
                isMandatory={false}
                readOnly={readOnly}
            />

            {/* Reference's Contact Phone Number */}
            <PhoneNumberInput
                ref={phoneNumberRef}
                title="Reference's Contact Phone Number"
                placeholder="Enter contact phone number"
                data={data?.phoneNumber}
                isMandatory={true}
                readOnly={readOnly}
            />

            <TextAreaInput
                ref={commentsRef}
                title="Comments"
                placeholder="comments..."
                data={data?.comments}
                isMandatory={false}
                disabled={readOnly}
            />

            {error && (
                <p className="text-red-600 text-sm mt-2">
                    {error}
                </p>
            )}

        </div>
    );
});

export default EmployeeReference;
